module.exports = __webpack_public_path__ + "static/media/Calculator.541adb94.png";